<div style="overflow: visible;">
  <form *ngIf="!useYesNo && !data.accountCompletion" #confirmForm="ngForm" novalidate>

    <div class="headline" *ngIf="headline">{{headline}}</div>
    <div class="text" *ngIf="text" [innerHtml]="text"></div>
    <div class="text error" *ngIf="errorText" [innerHtml]="errorText"></div>
    <div class="text" *ngIf="errorTextAfter" [innerHtml]="errorTextAfter"></div>

    <mat-form-field *ngIf="!hideInput" class="confirm-dialog-input" appearance="fill">
      <mat-label>{{inputTitle}}</mat-label>
      <input matInput type="text" [(ngModel)]='response.ResponseText' [attr.required]="requireInput ? '' : null" name="message">
    </mat-form-field>

    <div style="margin-top:30px;">
      <button mat-flat-button [disabled]="disableConfirmButton || isLoading || (requireInput && !confirmForm.valid)" (click)="save()" [color]="confirmButtonColor" style="margin-bottom: 5px; float: right;">
        <mat-icon>{{confirmButtonIcon}}</mat-icon>
        &nbsp;{{confirmButtonText}}&nbsp;
      </button>

      <button mat-flat-button *ngIf="showSecondaryConfirmButton" [disabled]="isLoading || (requireInput && showSecondaryConfirmButton && !confirmForm.valid)" (click)="save()" [color]="confirmButtonColor" style="margin-bottom: 5px; float: left;">
        <mat-icon>{{secondaryConfirmButtonIcon}}</mat-icon>
        &nbsp;{{secondaryButtonTitle}}&nbsp;
      </button>

      <button *ngIf="!hideCancelButton" [disabled]="isLoading" mat-flat-button (click)="cancel()" color="primary" style="margin-bottom: 5px; margin-right:10px; float: left;">
        <mat-icon>cancel</mat-icon>
        &nbsp;Avbryt&nbsp;
      </button>
    </div>
  </form>
  <form *ngIf="useYesNo && !data.accountCompletion" class="confirm-yes-no-dialog" #confirmForm="ngForm" novalidate>

    <div class="headline" *ngIf="headline">{{headline}}</div>
    <div class="text" *ngIf="text" [innerHtml]="text"></div>
    <div class="text error" *ngIf="errorText" [innerHtml]="errorText"></div>
    <div class="text" *ngIf="errorTextAfter" [innerHtml]="errorTextAfter"></div>

    <!--<mat-form-field *ngIf="!hideInput" style="width:100%;margin-top:25px;">
      <input matInput type="text" [(ngModel)]='response.ResponseText' placeholder="{{inputTitle}}" required name="message">
    </mat-form-field>-->

  <div class="confirm-yes-no-actions">

    <button type="button" mat-flat-button [disabled]="isLoading || !confirmForm.valid" (click)="saveYes()" [color]="confirmButtonColor">Ja</button>

    <button type="button" mat-flat-button [disabled]="isLoading || !confirmForm.valid" (click)="saveNo()" [color]="confirmButtonColor">Nej</button>

    <button *ngIf="!hideCancelButton" [disabled]="isLoading" mat-flat-button (click)="cancel()" color="primary" style="margin-bottom: 5px; margin-right:10px; float: left;">
      <mat-icon>cancel</mat-icon>
      &nbsp;Avbryt&nbsp;
    </button>
  </div>
  </form>
</div>

<form *ngIf="data.accountCompletion" class="account-completion-dialog" #accountForm="ngForm" novalidate>
  <h2 mat-dialog-title>{{headline}}</h2>
  <mat-dialog-content>
    <div class="account-completion-text" *ngIf="text" [innerHtml]="text"></div>
    <mat-form-field *ngIf="!hideInput && !useYesNo" class="confirm-dialog-input" appearance="fill">
      <mat-label>{{inputTitle}}</mat-label>
      <input matInput type="text" [(ngModel)]="response.ResponseText" (ngModelChange)="onInputChanged()" [required]="requireInput" [pattern]="data.inputPattern" name="message">
      <mat-error *ngIf="data.invalidInputText">{{data.invalidInputText}}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions [style.justify-content]="useYesNo || showSecondaryConfirmButton || !hideCancelButton ? 'space-between' : 'flex-end'">
    <ng-container *ngIf="useYesNo">
      <button type="button" mat-flat-button color="accent" [disabled]="isLoading" (click)="saveYes()">Ja</button>
      <button type="button" mat-flat-button color="accent" [disabled]="isLoading" (click)="saveNo()">Nej</button>
    </ng-container>
    <ng-container *ngIf="!useYesNo">
      <button type="button" mat-flat-button color="accent" *ngIf="showSecondaryConfirmButton" [disabled]="isLoading || (requireInput && !accountForm.valid)" (click)="save()">{{secondaryButtonTitle}}</button>
      <button type="button" mat-flat-button color="accent" *ngIf="!hideCancelButton" [disabled]="isLoading" (click)="cancel()">Avbryt</button>
      <button type="button" mat-flat-button color="accent" class="account-completion-confirm" [disabled]="disableConfirmButton || isLoading || (requireInput && !accountForm.valid)" (click)="save()">{{confirmButtonText}}</button>
    </ng-container>
    <div *ngIf="errorText" class="account-completion-error" role="alert" [innerHtml]="errorText"></div>
    <div *ngIf="errorTextAfter" class="account-completion-after" [innerHtml]="errorTextAfter"></div>
  </mat-dialog-actions>
</form>
